import React from 'react';
// Material UI core
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { withTranslation } from 'config/i18n';
import EsLogoFooter from 'components/shared/EsLogoFooter';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.grey[900],
    color: theme.palette.text.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem 2rem',
    [theme.breakpoints.up('lg')]: {
      padding: '1.5rem 4rem',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  typography: {
    // margin: theme.spacing(0, 6.25),
    fontWeight: 600,
    fontSize: '0.9375rem',
    [theme.breakpoints.down('md')]: {
      // marginBottom: '1rem',
      fontSize: '0.75rem',

    },
  },
  esLogoBox: {
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
      '& $typography': {
        // paddingTop: theme.spacing(2.5),
      },
    },
  },
}));

const Copyright = ({ t, er }) => {
  const classes = useStyles();
  return (
    <div className={`${classes.root} ${!er && classes.esLogoBox}`}>
      <EsLogoFooter />
      <Typography variant="subtitle2" className={classes.typography}>
        {t('fe_es_layout:footer.copyright')}
        {'  '}
        &copy;
        {new Date().getFullYear()}
        {' '}
        <Typography component="span">
          eagle
          <b>share</b>
        </Typography>
        .
      </Typography>
    </div>
  );
};

export default withTranslation(['fe_es_layout'])(Copyright);
